module.exports = __webpack_public_path__ + "img/3.4ed5ac1d.png";